import React from "react";
import s from "./greetingsText.module.css";

export const GreetingsText = () => (
    <div className={s.helloText}>
        <p className={s.greetings}>
            Hello, my name is Madina.
        </p>
    </div>
);
